import { render, staticRenderFns } from "./ContactTab.vue?vue&type=template&id=3844efc7"
import script from "./ContactTab.vue?vue&type=script&lang=js"
export * from "./ContactTab.vue?vue&type=script&lang=js"
import style0 from "./ContactTab.vue?vue&type=style&index=0&id=3844efc7&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports